import React, { useEffect } from 'react';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { azaStageazaPath } from '../../utilities/UrlPaths';
import './campaign.scss';

const embedUrl = 'https://public.domo.com/embed/pages/gnBWj';

const CampaignReporting = () => {
  const { houseRef } = useSelector(state => state.house);
  const path = azaStageazaPath();
  const urlStage = `${path}/house/${houseRef}/domo`;

  useEffect(() => {
    const fetchDomo = async () => {
      const { data } = await axios.get(urlStage, {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': '*',
          'Access-Control-Allow-Headers': '*',
          'Content-Type': 'application/json',
          Authorization: `${houseRef}*`,
        }
      });

      return data.data['embed-token'];
    };

    fetchDomo().then((token) => {
      // eslint-disable-next-line no-use-before-define
      const page = getGeneratedPageURL(token, embedUrl);
      const iframe = document.getElementById('iframe');
      iframe.srcdoc = page;
    });
  }, [urlStage, houseRef]);

  // eslint-disable-next-line no-shadow
  function getGeneratedPageURL(embedToken, embedUrl) {
    const source = `${''
      + '<html>\n'
      + '   <body>\n'
      + '        <form id="form" action="'}${embedUrl}" method="post">\n`
      + `        <input type="hidden" name="embedToken" value="${embedToken}">\n`
      + '        </form>\n'
      + '        <script>\n'
      + '        document.getElementById("form").submit();\n'
      + '        </script>\n'
      + '    </body>\n'
      + '</html>\n';

    return source;
  }

  return (
    <div className="iframe-container">
      <iframe id="iframe" src="" title="domo" className="iframe" scrolling="no" />
    </div>
  );
};

export default CampaignReporting;
